import { NavLink } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";

import withDocumentTitle from "../withDocumentTitle";

import WelcomePopup from "./WelcomePopup";
import RouteAlertNotification from "./RouteAlertNotification";
import TogglePreviousLandingPage from "./TogglePreviousLandingPage";
import VolumeLineChart from "./VolumeLineChart";

import { pages } from "../../constants";

import CDKIntegration from "../../assets/images/CDKIntegration.jpg";
import AccountLinkingAndSwitchingPT from "../../assets/images/Account Linking And Switching 1830x250 - render 2 space-around 4x - Downscaled 4x PT.png";
import CustomerReturnPortal from "../../assets/images/Return Portal Centered Flatter Lighting Promo 2.png";
import ReturnPermissionsAndRequestsPromoBanner from "../../assets/images/ReturnPermissionsAndRequests Promo Banner.png";

const carouselOptionsNonMobile = [
  {
    imgPath: ReturnPermissionsAndRequestsPromoBanner,
    title: "Return Requests and Permissions",
    description: (
      <>
        Configure permissions for order returns on a per customer basis. <br />{" "}
        Auto-Approve, By Approval, or Disabled
      </>
    ),
    alt: "Customer Return Portal Promo Banner",
    learnMoreLink: pages.helpPage.url,
  },
  {
    imgPath: AccountLinkingAndSwitchingPT,
    title: "Account Linking",
    description: "Link your accounts and toggle between them!",
    alt: "Account Linking Promo Banner",
    learnMoreLink: pages.viewProfile.url,
  },
  {
    imgPath: CDKIntegration,
    title: "Diligent's CDK Integration is Here!",
    description: "Let us import your CDK Orders and spend less time typing!",
    alt: "CDK Integration Promo Banner",
    learnMoreLink: pages.cdkIntroduction.url,
  },
  {
    imgPath: CustomerReturnPortal,
    title: "Customer Return Portal",
    description: (
      <>
        Did you know your customers can track and place returns using this
        client portal?
        <br />A customer return portal login is required.
      </>
    ),
    alt: "Customer Return Portal Promo Banner",
  },
];

function ClientDashboardPage() {
  return (
    <div className="tw-mt-4">
      <WelcomePopup />

      <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-y-10">
        <div className="lg:tw-col-span-2">
          <Carousel className="dashboard-feature-carousel tw-w-full">
            {carouselOptionsNonMobile.map((option, index) => (
              <Carousel.Item key={index}>
                <img
                  className="tw-block tw-w-full brightness-75 tw-object-cover"
                  loading="lazy"
                  height={250}
                  src={option.imgPath}
                  alt={option.alt}
                />
                <Carousel.Caption className="tw-mb-2">
                  <h2 className="tw-text-xl md:tw-text-4xl dashboard-feature-carousel-text">
                    {option.title}
                  </h2>
                  <p className="tw-text-sm md:tw-text-base dashboard-feature-carousel-text">
                    {option.description}
                  </p>
                  {option.learnMoreLink && (
                    <NavLink
                      className="btn btn-primary"
                      to={option.learnMoreLink}
                    >
                      Learn More
                    </NavLink>
                  )}
                </Carousel.Caption>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
        <div className="lg:tw-col-span-2 tw-h-114">
          <VolumeLineChart />
        </div>
        <div className="tw-h-72">
          <RouteAlertNotification />
        </div>
        <div className="tw-justify-self-end lg:tw-h-72">
          <div className="tw-flex tw-items-end tw-h-full">
            <TogglePreviousLandingPage />
          </div>
        </div>
      </div>
    </div>
  );
}

export default withDocumentTitle(ClientDashboardPage, {
  documentTitle: "Dashboard",
  showTitle: false,
});
